import React from 'react';
import { createRoot } from 'react-dom/client'

import '../stylesheets/custom.scss';
import 'bootstrap/scss/bootstrap-utilities.scss';

import NewsletterModal from '../src/components/newsletterModal/NewsletterModal';
import LoginModal from '../src/authentication/LoginModal';
import SignupModal from '../src/authentication/SignupModal';

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.getElementsByClassName('newsletter-modal-container');
  Array.from(containers).forEach((container) => {
    const root = createRoot(container);
    root.render(
      <NewsletterModal />
    );
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.getElementsByClassName('login-modal-container');
  Array.from(containers).forEach((container) => {
    const root = createRoot(container);
    root.render(
      <LoginModal
        btnClasses="header-link-item"
        createSessionPath="/api/sessions"
      />
    );
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.getElementsByClassName('signup-modal-container');
  Array.from(containers).forEach((container) => {
    const root = createRoot(container);
    root.render(
      <SignupModal
        btnClass="header-link-item"
        btnText="sign up"
      />
    );
  });
});
